import StudentAPI from '@/apis/business/student/student-api.js'
import NotifySmartAPI from '@/apis/business/common/notify-smart-api.js'
import GiftExchangeHistoryAPI from '@/apis/business/student/gift-exchange-history-api.js'

export default {
  namespaced: true,
  state: {
    students: [],
    student: {},
    currentStudent: {},
    ranks: [],
    parents: [],
    isLastPageRanks: false,
    grade: 0,
    gifts: [],
    achievements: [],
    showBtnViewMore: true,
    notifySmart: []
  },

  getters: {},

  mutations: {
    // Khởi tạo state student
    // Do sử dụng khi gọi API nên sẽ cập nhật cả state currentStudent để dữ liệu luôn mới nhất
    setStudent (state, student) {
      state.student = student || {}
      state.currentStudent = JSON.parse(JSON.stringify(student))
      state.currentStudent.Birthday = student.Birthday
    },

    // set giá trị cho khối cho học sinh
    setGrade (state, grade) {
      state.grade = grade
    },

    // Khởi tạo state students
    setStudents (state, students) {
      state.students = students
    },

    // Khởi tạo state ranks
    setRanks (state, data) {
      state.ranks = data?.PageData
    },

    // set giá trị thành tích (xem tất cả)
    setAchievements (state, data) {
      var dataRes = data?.PageData
      if (dataRes && dataRes.length > 0) {
        dataRes.forEach((element) => {
          state.achievements.push(element)
        })
      }
      state.showBtnViewMore = !(data?.Total === state.achievements.length)
    },

    // clear dữ liệu thành tích
    setAchievementsEmpty (state) {
      state.achievements = []
    },

    // Cập nhật state student
    updateStudent (state, student) {
      state.student = student
    },

    // Cập nhật state currentStudent
    updateCurrentStudent (state, student) {
      state.currentStudent = JSON.parse(JSON.stringify(state.student))
      state.currentStudent.Birthday = state.student.Birthday
      if (student.ImageFrame !== undefined) {
        state.currentStudent.ImageFrame = student.ImageFrame
      }
    },

    // Khởi tạo state parent
    setParents (state, parents) {
      state.parents = parents
    },

    // Reset state student về state currentStudent
    resetStudent (state) {
      state.student = JSON.parse(JSON.stringify(state.currentStudent))
      state.student.Birthday = state.currentStudent.Birthday
    },

    setGifts (state, gifts) {
      state.gifts = gifts
    },

    // Trừ điểm học sinh
    deductStudentPoint (state, point) {
      if (state.student.Point && state.student.Point >= point) {
        state.student.Point -= point
        state.currentStudent.Point -= point
      }
    },

    insertGift (state, gift) {
      state.gifts.push(gift)
    },

    // Khởi tạo danh sách notify
    setNotifySmart (state, notify) {
      state.notifySmart = notify
    }
  },

  actions: {
    /**
     * @description Load toàn bộ học sinh từ API
     * @param {*} context
     * @author BNDung
     */
    setStudents (context) {
      return new Promise((resolve, reject) => {
        StudentAPI.getAsync()
          .then((res) => {
            context.commit('setStudents', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @param {*} context
     * @param {*} studentCode
     * @returns set student
     * @author BNDung
     */
    async getStudent (context, StudentID) {
      return new Promise((resolve, reject) => {
        StudentAPI.getStudent(StudentID)
          .then((res) => {
            resolve(res)
            context.commit('setStudent', res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Gọi API lấy danh sách ranks của học sinh
     * @param {*} context
     * @param {*} param
     * @returns List
     * @author PBac
     */
    async getRanks (context, param) {
      return new Promise((resolve, reject) => {
        StudentAPI.getAsync('/ranks', { params: param })
          .then((res) => {
            const data = res?.Data || []
            resolve(res)
            context.commit('setRanks', data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Cập nhật thông tin học sinh
     */
    updateStudent (context, params) {
      return new Promise((resolve, reject) => {
        StudentAPI.putAsync('', params).then((res) => {
          context.commit('updateCurrentStudent', params)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * @description Gọi API gửi mã OTP về cho người dùng
     * @param {*} context
     * @param {*} params
     * @returns
     * @author PBac
     */
    getOTPCode (context, params) {
      return new Promise((resolve, reject) => {
        StudentAPI.postAsync(
          `/otp?userName=${params.userName}&phoneNumber=${params.phoneNumber}`
        )
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Gọi API xác thực mã OTP người dùng nhập
     * @param {*} context
     * @param {*} params
     * @returns
     * @author PBac
     */
    confirmOTPCode (context, params) {
      return new Promise((resolve, reject) => {
        StudentAPI.postAsync(
          `/otp/confirm?userName=${params.UserName}&code=${params.Code}`
        )
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Gọi API lấy thông tin phụ huynh học sinh
     * @param {*} context
     * @returns
     * @author PBac
     */
    getParents (context) {
      return new Promise((resolve, reject) => {
        StudentAPI.getAsync('/parent')
          .then((res) => {
            resolve(res)
            context.commit('setParents', JSON.parse(res.Data.Data))
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * @description Gọi API lấy khối của học sinh
     * @param {*} context
     * @returns
     * @author TTLONG
     */
    getGradeStudent (context) {
      return new Promise((resolve, reject) => {
        StudentAPI.getAsync('/grade')
          .then((res) => {
            context.commit('setGrade', res)

            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy lịch sử đổi quà của học sinh
     * @param {*} context
     * @returns
     * @author PBac
     */
    getGiftExchangeHistory (context) {
      return new Promise((resolve, reject) => {
        GiftExchangeHistoryAPI.getAsync()
          .then((res) => {
            resolve(res)
            context.commit('setGifts', res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Gọi API lấy danh sách ranks của học sinh (loadMore)
     * @param {*} context
     * @param {*} param
     * @returns List
     * @author VDDung1
     */
    async getAchievementsLoadMore (context, param) {
      return new Promise((resolve, reject) => {
        StudentAPI.getAsync('/ranks', { params: param })
          .then((res) => {
            const data = res?.Data || []
            resolve(res)
            context.commit('setAchievements', data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Gọi api học sinh đổi quà
     * @param {*} context
     * @param {*} params
     * @returns
     * @author PBac
     */
    exchangeGift (context, params) {
      return new Promise((resolve, reject) => {
        GiftExchangeHistoryAPI.postAsync('/exchange', params).then((res) => {
          if (res.Data) {
            context.commit('deductStudentPoint', params.Point)
            context.commit('insertGift', params)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * @author NVThang
     * @description lấy danh sách notify
     * @param {*} context
     */
    async getNotifySmart (context) {
      const res = await NotifySmartAPI.getAsync('', { params: { Skip: 0, Limit: 3 } })
      if (res.IsSuccess) {
        context.commit('setNotifySmart', res.Data)
      }
    },

    /**
     * @author NVThang
     * @description set lại preview của notify
     * @param {*} context
     * @param {*} params
     */
    async setNotifyPreview (context, params) {
      await NotifySmartAPI.putAsync(`/${params.Id}`, params)
    }
  }
}
